import React, { memo, useRef } from "react";

import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Card, CardMedia, Link } from "@mui/material";
import { makeStyles } from "@mui/styles";
import shuffle from "lodash/shuffle";
import Types from "prop-types";
import AliceCarousel from "react-alice-carousel";

const styles = makeStyles({
  prevBtn: {
    width: "40px",
    top: 0,
    left: 0,
  },
  nextBtn: {
    width: "40px",
    top: 0,
    right: 0,
  },
});

const MyJobSlideBanner = ({ banners }) => {
  const classes = styles();
  const carouselRef = useRef();

  const bannersShuffle = shuffle(banners);

  return (
    <Card className="jvs-m-b15 position-relative">
      <AliceCarousel
        autoPlay
        // autoHeight
        infinite
        autoPlayInterval={10000}
        controlsStrategy="responsive"
        disableDotsControls
        disableButtonsControls
        ref={carouselRef}
      >
        {bannersShuffle &&
          bannersShuffle.map((banner) => (
            <CardMedia key={banner?.url}>
              <Link href={banner?.url} target="_blank">
                <img src={banner?.image} className="w-100" alt="" />
              </Link>
            </CardMedia>
          ))}
      </AliceCarousel>
      <ChevronLeft
        onClick={() => carouselRef.current.slidePrev()}
        classes={{ root: classes.prevBtn }}
        className="position-absolute h-100"
        role="button"
      />
      <ChevronRight
        onClick={() => carouselRef.current.slideNext()}
        classes={{ root: classes.nextBtn }}
        className="position-absolute h-100"
        role="button"
      />
    </Card>
  );
};

MyJobSlideBanner.propTypes = {
  banners: Types.arrayOf(Object),
};

export default memo(MyJobSlideBanner);
